import { render, staticRenderFns } from "./ListFormTopList.vue?vue&type=template&id=612f2c6f&scoped=true&"
import script from "./ListFormTopList.vue?vue&type=script&lang=js&"
export * from "./ListFormTopList.vue?vue&type=script&lang=js&"
import style0 from "./ListFormTopList.vue?vue&type=style&index=0&id=612f2c6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612f2c6f",
  null
  
)

export default component.exports